import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Message, Table } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import { PagingParams } from "../../app/models/pagination";
import MyPaging from "../../app/common/form/MyPaging";
import { formatCurrency } from "../../app/common/util/functions";

type Props = {
    id: string;
}

export default observer(function PartDetailsLocations({
    id
}: Props) {
    const { t } = useTranslation(["common", "customer", "inventory"]);
    const {
        inventoryPartDetailsStore
    } = useStore();

    const {
        selectedPartDetails,
        getSelectedPartDetailsLocations,
        partDetailsLocationPagingParams,
        partDetailsLocationPagination,
        setPartDetailsLocationPagingParams,
        resetPartDetailsLocationsRegistry,
        loadInventoryPartLocations,
    } = inventoryPartDetailsStore;

    function listOnClick(value: number) {
        if (value > 0 && partDetailsLocationPagination && value < partDetailsLocationPagination?.totalPages + 1) {
            setPartDetailsLocationPagingParams(new PagingParams(value));
            resetPartDetailsLocationsRegistry();
            loadInventoryPartLocations(id);
        }
    }


    return (
        <Table striped unstackable className="dnxTable">
            <Table.Header>
                <Table.Row key={"notesheader"}>
                    <Table.HeaderCell>
                        {`${t("labels.location", { ns: "inventory" })}`}
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                        {`${t("labels.cost", { ns: "inventory" })}`}
                    </Table.HeaderCell>
                    <Table.HeaderCell width={8}>
                        {`${t("labels.notes", { ns: "inventory" })}`}
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {getSelectedPartDetailsLocations && getSelectedPartDetailsLocations.length ?
                    getSelectedPartDetailsLocations.map(l => (
                        <Table.Row key={l.id}>
                            <Table.Cell data-label={`${t("name", { ns: "common" })}:`}>
                                {l.name}
                            </Table.Cell>
                            <Table.Cell
                                data-label={`${t("labels.cost", { ns: "inventory" })}:`}
                            >
                                {formatCurrency(selectedPartDetails?.averageCost ?? 0)}
                            </Table.Cell>
                            <Table.Cell
                                data-label={`${t("note", { ns: "customer" })}:`}
                            >
                                {l.notes}
                            </Table.Cell>
                        </Table.Row>
                    )) : (
                        <Table.Row key={"noItems1"}>
                            <Table.Cell
                                className="noPaddingLeft"
                                width="8"
                                colSpan={8}
                            >
                                <Message
                                    color="yellow"
                                    className="textAlignCenter fontStyleItalic"
                                >
                                    {t("grid_noItems", { ns: "common" })}
                                </Message>
                            </Table.Cell>
                        </Table.Row>
                    )
                }
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.Cell colSpan="6">
                        <MyPaging
                            itemCount={partDetailsLocationPagination ? partDetailsLocationPagination.totalItems : 10}
                            pageSize={partDetailsLocationPagingParams.pageSize}
                            currentPage={partDetailsLocationPagination ? partDetailsLocationPagination.currentPage : 1}
                            onClick={listOnClick}
                            onChange={listOnClick}
                            floated="right"
                        ></MyPaging>
                    </Table.Cell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
})